export const APP_TYPES = {
    FIRE_TV: 'firetv',
    ROKU: 'roku',
    MOBILE_APP: 'app',
    WEB: 'web',
    SKY: 'sky'
}